import { Box, Text } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import i18n from 'modules/core/lib/i18n'

export const EmptyVariablesList = () => {
  return (
    <Box flexDirection="column" gap="s4" padding="s16">
      <Text.Normal>
        {i18n.t('documents.document_templates.variables_list.no_detected_variables.title')}
      </Text.Normal>
      <Text.Normal color={'grey700'}>
        {i18n.t('documents.document_templates.variables_list.no_detected_variables.content')}
      </Text.Normal>
      <HelpCenterLink name="document_templates">
        {i18n.t('documents.document_templates.variables_list.learn_more')}
      </HelpCenterLink>
    </Box>
  )
}
